import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import QuestionRowSelector from './QuestionRowSelector';
import QuestionRow from './QuestionRow';
import getLogger from '@ignitesales/logger-es';

const logger = getLogger({ component: 'QuestionBuilder' });

/* eslint-disable react/prop-types */
class RowBuilder extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    showAllMode: PropTypes.bool,
    checkboxMode: PropTypes.bool,
    toggle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  constructor(props) {
    super(props);
    const { values = [], showSelect } = props;
    this.state = {
      showSelect: !values.length || showSelect,
    };
  }

  changeShowSelectState = (active) => {
    this.setState({
      showSelect: active,
    });
  };

  render() {
    const {
      className,
      rows = [],
      renderQuestion,
      onChange,
      values = [],
      toggle,
      showAllMode = false,
      checkboxMode = false,
      renderRowBtn = <span>Add Row</span>,
      renderGoalLabel = <span>What is your goal</span>,
      renderTrashBtn = <span>X</span>,
    } = this.props;
    const { showSelect } = this.state;

    const cssBem = 'questionBuilder';
    const flaggedRows = rows.map((row) => {
      row.active = values.indexOf(row.id) >= 0;
      return row;
    });
    const activeRows = values.map((v) =>
      flaggedRows.find((row) => row.id === v)
    );
    const inactiveRows = flaggedRows.filter((row) => !row.active);
    const questionRows = [...activeRows, ...inactiveRows];

    const showAllRows = showAllMode || checkboxMode;

    const onRowChange = (rowId, added) => {
      if (added) {
        //If a row was just added, then let's hide the Row Selector
        this.changeShowSelectState(false);
      } else {
        //If a row was removed and if no others rows are visible, show the Row Selector
        this.changeShowSelectState(
          !questionRows.filter((q) => q.active).length
        );
      }
      onChange(rowId, added);
    };

    const renderRowSelect = () => {
      const addRow = (rowId) => {
        logger.info('row added:', rowId);
        onRowChange(rowId, true);
      };
      const rowSelectorRemoved = () => {
        logger.info('removing row selector');
        this.changeShowSelectState(false);
      };
      return inactiveRows.length && !showAllRows && showSelect ? (
        <QuestionRowSelector
          availableRows={inactiveRows}
          onChange={addRow}
          onRemove={rowSelectorRemoved}
          disableRemove={inactiveRows.length === questionRows.length}
          renderTrashBtn={renderTrashBtn}
          renderGoalLabel={renderGoalLabel}
        />
      ) : null;
    };

    const renderedActiveRows = questionRows.map((row, index) => {
      const activateRow = () => {
        logger.info('row activated:', row.id);
        onRowChange(row.id, true);
      };
      const rowRemoved = () => {
        logger.info('row removed:', row.id);
        onRowChange(row.id, false);
      };
      return row.active || showAllRows ? (
        <QuestionRow
          row={row}
          key={index}
          onRemove={rowRemoved}
          onActivate={activateRow}
          isToggle={row.id === toggle}
          showAllMode={showAllMode}
          checkboxMode={checkboxMode}
          className={`${cssBem}__row`}
          renderQuestion={renderQuestion}
          renderTrashBtn={renderTrashBtn}
          renderGoalLabel={renderGoalLabel}
        />
      ) : null;
    });

    const renderedAddRowButton =
      inactiveRows.length && !showAllRows && !showSelect ? (
        <div className={`${cssBem}__addRowButton`}>
          <button onClick={() => this.changeShowSelectState(true)}>
            {renderRowBtn}
          </button>
        </div>
      ) : null;

    const classesObj = {};
    classesObj[`${cssBem}--showAllMode`] = showAllMode;
    classesObj[`${cssBem}--checkboxMode`] = checkboxMode;
    const classes = classNames(className, cssBem, classesObj);

    return (
      <div className={classes}>
        {renderedActiveRows}
        {renderRowSelect()}
        {renderedAddRowButton}
      </div>
    );
  }
}

export default RowBuilder;
